export const inspectionHeader = [
  {
    id: 'id',
    label: '관리번호',
  },
  {
    id: 'name',
    label: '시설명',
  },
  {
    id: 'location',
    label: '위치',
  },
  {
    id: 'area',
    label: '설치면적',
  },
  {
    id: 'date',
    label: '설치일자',
  },
  {
    id: 'type',
    label: '유형',
  },
  {
    id: 'budget',
    label: '사업비(국비/시비/구비)',
  },
  {
    id: 'img',
    label: '전경사진',
  },
  {
    id: 'facility',
    label: '기구명',
  },
  {
    id: 'status',
    label: '시설상태',
  },
  {
    id: 'etc',
    label: '상태비고',
  },
  {
    id: 'inspection',
    label: '점검(보수)일시',
  },
  {
    id: 'content',
    label: '점검(보수)내용',
  },
];

export const inspectionBulkHeader = [
  {
    id: 'id',
    label: '관리번호',
  },
  {
    id: 'status',
    label: '시설상태',
  },
  {
    id: 'etc',
    label: '상태비고',
  },
  {
    id: 'inspector',
    label: '점검자',
  },
  {
    id: 'inspection',
    label: '점검(보수)일시',
  },
  {
    id: 'content',
    label: '점검(보수)내용',
  },
];
